import React, { forwardRef } from 'react';

import { StyledIcon } from '../StyledIcon';

const SD = forwardRef((props, ref) => (
  <StyledIcon ref={ref} viewBox="0 0 24 24" a11yTitle="SD" {...props}>
    <path d="M16.1719 1C16.9674 1.00008 17.7304 1.31637 18.293 1.87891L21.1211 4.70703L21.3203 4.92676C21.7578 5.46058 21.9999 6.13188 22 6.82812V20C22 21.6569 20.6569 23 19 23H5C3.34315 23 2 21.6569 2 20V4C2 2.34315 3.34315 1 5 1H16.1719ZM5 3C4.44772 3 4 3.44772 4 4V20C4 20.5523 4.44772 21 5 21H19C19.5523 21 20 20.5523 20 20V6.82812C19.9999 6.59606 19.9193 6.37224 19.7734 6.19434L19.707 6.12109L16.8789 3.29297C16.6914 3.1055 16.437 3.00008 16.1719 3H5ZM7 4C7.55228 4 8 4.44772 8 5V9C8 9.55229 7.55228 10 7 10C6.44772 10 6 9.55229 6 9V5C6 4.44772 6.44772 4 7 4ZM10 4C10.5523 4 11 4.44772 11 5V9C11 9.55229 10.5523 10 10 10C9.44772 10 9 9.55229 9 9V5C9 4.44772 9.44772 4 10 4ZM13 4C13.5523 4 14 4.44772 14 5V9C14 9.55229 13.5523 10 13 10C12.4477 10 12 9.55229 12 9V5C12 4.44772 12.4477 4 13 4ZM16 6C16.5523 6 17 6.44772 17 7V9C17 9.55229 16.5523 10 16 10C15.4477 10 15 9.55229 15 9V7C15 6.44772 15.4477 6 16 6Z" fill="#000" />
  </StyledIcon>
));

SD.displayName = 'SD';

export { SD };
